import './TaskLinksContainer.scss'

import React from 'react'
import PropTypes from 'prop-types'
import TaskLink from './TaskLink'

const TaskLinksContainer = props => {
  const { taskLinks, deleteTaskLink, allowDelete, localize } = props
  const sortTaskLinks =
    (taskLink, nextTaskLink) => taskLink.createdOn.localeCompare(nextTaskLink.createdOn)

  return taskLinks.length > 0 && (
    <div className='task-modal__task-links'>
      {
        taskLinks.sort(sortTaskLinks).map((taskLink) => {
          return (
            <TaskLink
              key={taskLink.id}
              taskLink={taskLink}
              deleteTaskLink={deleteTaskLink}
              allowDelete={allowDelete}
              localize={localize}
              />
          )
        })
      }
    </div>
  )
}

TaskLinksContainer.defaultProps = {
  taskLinks: [],
  allowDelete: false,
  localize: str => str
}

TaskLinksContainer.propTypes = {
  taskLinks: PropTypes.array.isRequired,
  deleteTaskLink: PropTypes.func.isRequired,
  allowDelete: PropTypes.bool,
  localize: PropTypes.func
}

export default TaskLinksContainer



// WEBPACK FOOTER //
// ./src/components/TaskDetails/TaskLinksContainer.js